(ns kyber.components.composite.media-control-bar
  (:require [re-frame.core :as re-frame]

            [kyber.styles.core :refer [gs styles->classes]]
            [kyber.components.composite.rewind :as rewind]
            [kyber.components.composite.play-pause :as play-pause]
            [kyber.components.composite.rate :as rate]
            [kyber.components.composite.volume :as volume]
            [kyber.components.composite.scrubber :as scrubber]

            [kyber.constants :refer [media-control-bar-height]]))

(def classes
  (styles->classes
   {:media-controls-container
    {:padding (gs [:spacing :p8])
     :display :flex
     :align-items :center
     :width "100%"
     :height (str media-control-bar-height "px")
     :min-height (str media-control-bar-height "px")
     :background (gs [:colors :true-white])}}))

(defn render
  [{:keys [player-key]}]
  (let [player-attributes (re-frame/subscribe
                           [:media-player/player-attributes player-key])]
    (fn []
      (when (some? @player-attributes)
        (let [{:keys [player-state
                      buffering
                      volume
                      show-volume-controls
                      rate]} @player-attributes]
          [:div {:class (:media-controls-container classes)}
           [rewind/render {:buffering buffering
                           :player-key player-key}]

           [play-pause/render {:player-state player-state
                               :player-key player-key}]

           [rate/render {:rate rate
                         :player-key player-key}]

           [volume/render {:volume volume
                           :show-volume-controls show-volume-controls
                           :player-key player-key}]

           [scrubber/render {:player-attributes player-attributes
                             :player-key player-key}]])))))
